    <div class="oi-main-dshd">
    
    <div class="container-fluid">
    <div class="row">
    <div class="col-md-8"><h2>History</h2></div>
    <div class="col-md-4"><div class="oi-hist-switch">
    <div class="oi-hs-text1">Show All</div>
    <label class="switch">
      <input type="checkbox" checked>
      <span class="slider round"></span>
    </label>
    
    </div>
    
    </div>
    </div>
    
    
    
    
    <div class="row">
    <div class="col-md-12">
    <div class="oi-history-bx-main">
    <div class="oi-history-top">
    
    <div class="oi-history-date">28 Feb 2024 | 02:30 PM</div>
    </div>
    
    <div class="oi-history-box box">
    <div class="oi-history-qns">What is personal insurance? 
    <span>
    <div class="oi-hs-source"><strong>Source:</strong> Vikas Kumar</div>
    <div class="oi-hs-tag">
    <a href="#">INSURANCE</a>
    <a href="#">PERSONAL</a>
    <a href="#">POLICY</a>
    </div>
    
    </span>
    
    </div>
    <div class="oi-history-ans">Personal insurance refers to a range of policies that individuals purchase to protect themselves, their families, and their assets against financial losses resulting from unforeseen events such as accidents, illnesses, or property damage.</div>
    </div>
    </div>
    
    
    
    <div class="oi-history-bx-main">
    <div class="oi-history-top">
    
    <div class="oi-history-date">28 Feb 2024 | 02:30 PM</div>
    </div>
    
    <div class="oi-history-box box">
    <div class="oi-history-qns">What is personal insurance?
    
    <span>
    <div class="oi-hs-source"><strong>Source:</strong> Vikas Kumar</div>
    <div class="oi-hs-tag">
    <a href="#">INSURANCE</a>
    <a href="#">PERSONAL</a>
    <a href="#">POLICY</a>
    </div>
    
    </span>
    </div>
    <div class="oi-history-ans">Personal insurance refers to a range of policies that individuals purchase to protect themselves, their families, and their assets against financial losses resulting from unforeseen events such as accidents, illnesses, or property damage.</div>
    </div>
    </div>
    
    
    <div class="oi-history-bx-main">
    <div class="oi-history-top">
    
    <div class="oi-history-date">28 Feb 2024 | 02:30 PM</div>
    </div>
    
    <div class="oi-history-box box">
    <div class="oi-history-qns">What is personal insurance?
    
    <span>
    <div class="oi-hs-source"><strong>Source:</strong> Vikas Kumar</div>
    <div class="oi-hs-tag">
    <a href="#">INSURANCE</a>
    <a href="#">PERSONAL</a>
    <a href="#">POLICY</a>
    </div>
    
    </span>
    </div>
    <div class="oi-history-ans">Personal insurance refers to a range of policies that individuals purchase to protect themselves, their families, and their assets against financial losses resulting from unforeseen events such as accidents, illnesses, or property damage.</div>
    </div>
    </div>
    
    
    
    <div class="oi-history-bx-main">
    <div class="oi-history-top">
    
    <div class="oi-history-date">28 Feb 2024 | 02:30 PM</div>
    </div>
    
    <div class="oi-history-box box">
    <div class="oi-history-qns">What is personal insurance?
    
    <span>
    <div class="oi-hs-source"><strong>Source:</strong> Vikas Kumar</div>
    <div class="oi-hs-tag">
    <a href="#">INSURANCE</a>
    <a href="#">PERSONAL</a>
    <a href="#">POLICY</a>
    </div>
    
    </span>
    </div>
    <div class="oi-history-ans">Personal insurance refers to a range of policies that individuals purchase to protect themselves, their families, and their assets against financial losses resulting from unforeseen events such as accidents, illnesses, or property damage.</div>
    </div>
    </div>
    
    
    
    <div class="oi-history-bx-main">
    <div class="oi-history-top">
    
    <div class="oi-history-date">28 Feb 2024 | 02:30 PM</div>
    </div>
    
    <div class="oi-history-box box">
    <div class="oi-history-qns">What is personal insurance?
    <span>
    <div class="oi-hs-source"><strong>Source:</strong> Vikas Kumar</div>
    <div class="oi-hs-tag">
    <a href="#">INSURANCE</a>
    <a href="#">PERSONAL</a>
    <a href="#">POLICY</a>
    </div>
    
    </span>
    </div>
    <div class="oi-history-ans">Personal insurance refers to a range of policies that individuals purchase to protect themselves, their families, and their assets against financial losses resulting from unforeseen events such as accidents, illnesses, or property damage.</div>
    </div>
    </div>
    
    
    <div class="oi-history-bx-main">
    <div class="oi-history-top">
    
    <div class="oi-history-date">28 Feb 2024 | 02:30 PM</div>
    </div>
    
    <div class="oi-history-box box">
    <div class="oi-history-qns">What is personal insurance?
    <span>
    <div class="oi-hs-source"><strong>Source:</strong> Vikas Kumar</div>
    <div class="oi-hs-tag">
    <a href="#">INSURANCE</a>
    <a href="#">PERSONAL</a>
    <a href="#">POLICY</a>
    </div>
    
    </span>
    </div>
    <div class="oi-history-ans">Personal insurance refers to a range of policies that individuals purchase to protect themselves, their families, and their assets against financial losses resulting from unforeseen events such as accidents, illnesses, or property damage.</div>
    </div>
    </div>
    
    
    
    <div class="oi-history-bx-main">
    <div class="oi-history-top">
    
    <div class="oi-history-date">28 Feb 2024 | 02:30 PM</div>
    </div>
    
    <div class="oi-history-box box">
    <div class="oi-history-qns">What is personal insurance?
    <span>
    <div class="oi-hs-source"><strong>Source:</strong> Vikas Kumar</div>
    <div class="oi-hs-tag">
    <a href="#">INSURANCE</a>
    <a href="#">PERSONAL</a>
    <a href="#">POLICY</a>
    </div>
    
    </span>
    </div>
    <div class="oi-history-ans">Personal insurance refers to a range of policies that individuals purchase to protect themselves, their families, and their assets against financial losses resulting from unforeseen events such as accidents, illnesses, or property damage.</div>
    </div>
    </div>
    
    
    
    </div>
    </div>
    
    
    
    
    </div>
    
    
    </div>
    